import { Button, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutTrackingController extends Layout {
    buttonMPact: Button;
    labelTrackingHeader: Label;
    panelMainContainer: Panel;
}
